import { render, staticRenderFns } from "./AtomStatusPill.vue?vue&type=template&id=c6fffc68&scoped=true"
import script from "./AtomStatusPill.vue?vue&type=script&lang=js"
export * from "./AtomStatusPill.vue?vue&type=script&lang=js"
import style0 from "./AtomStatusPill.vue?vue&type=style&index=0&id=c6fffc68&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6fffc68",
  null
  
)

export default component.exports